import Title from 'Components/Atoms/Title/Title';
import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { MODULES } from 'Services/Settings/Modules/Helper';
import { Tab, useTab } from 'Services/Tab/TabContext';
import { getContactByEntityId } from 'Store/Modules/ContactModule/Selectors';
import { StoreState } from 'Store/Reducers';
import { getEntitiesById, getEntityById } from 'Store/Settings/Entities/Selectors';
import { getModulesByEntityIdByModule } from 'Store/Settings/Modules/Selectors';
import styles from './ContactHeader.module.sass';
import ContactHeaderItem from './ContactHeaderItem/ContactHeaderItem';
import ContactHeaderItemLabel from './ContactHeaderItemLabel/ContactHeaderItemLabel';

const ContactHeader = ({
    record_id, entity_id,

    entity, entityById,
    contact_methods, modulesByEntityIdByModule,
    
    ...props
}: ContactHeaderProps) => {
    const { setTab } = useTab();
    const [copyTimer, setCopyTimer] = useState<any>(null);
    const [copyId, setCopyId] = useState<any>(null);

    const copyValue = (copyId: string) => () => {
        if (!navigator.clipboard) return;

        navigator.clipboard.writeText(copyId);
        setCopyId(copyId);

        clearTimeout(copyTimer);
        setCopyTimer(
            setTimeout(() => {
                setCopyId(null);
            }, 500)
        );
    }

    const handleTabClick = () => setTab(Tab.CONTACT);

    const {
        phones,
        email,
        linkedin
    } = useMemo(() => {
        let phones: any = [];
        let email: any = [];
        let linkedin: any = [];

        contact_methods?.forEach((i: any) => {
            if (i.type === 'phone') phones.push(i);
            if (i.type === 'email') email.push(i);
            if (i.type === 'linkedin') linkedin.push(i);
        });

        return {
            phones,
            email,
            linkedin
        }
    }, [contact_methods]);
    
    return <div className={styles['contactheader']}>
        {
            phones?.length > 0 
            && <div className={styles['contactheader__list']}>
                <Title
                    size='xsmall'
                    weight='semibold'
                    transform='uppercase'
                    color='secondary'
                >
                    Telefoon 
                </Title>
                {
                    phones
                    ?.sort((a, b) => Number(b.is_primary) - Number(a.is_primary))
                    ?.slice(0, 3)
                    ?.map(i => <div className={styles['contactheader__list-item']}>
                            <span onClick={copyValue(i?.value)}>{ i?.value === copyId ? 'Gekopieerd!' : i?.value }</span>
                            {
                                entity.name === 'candidate'
                                && i?.is_primary
                                && <span className={styles['contactheader__list-item-primary']}>(primair)</span>
                            }
                            {
                                entity.name === 'business_unit'
                                && i?.label
                                && <ContactHeaderItemLabel
                                    list={
                                        modulesByEntityIdByModule
                                            ?.[entity_id]
                                            ?.[MODULES.CONTACT]
                                            ?.configuration
                                            ?.labels
                                            ?.map(i => ({
                                                label: i.name,
                                                value: i.id
                                            }))
                                    }
                                    values={i?.label}
                                />
                            }
                            {
                                entity.name === 'contact'
                                && i?.relation
                                && <ContactHeaderItem
                                    entity_name={entityById?.[modulesByEntityIdByModule?.[entity_id]?.[MODULES.CONTACT]?.configuration?.[i.type]?.relation]?.name}
                                    values={i?.relation}
                                />
                            }
                        </div>    
                    )
                }
                {
                    phones
                    ?.slice(3)
                    ?.length > 0
                    && <span
                        onClick={handleTabClick}
                        className={styles['contactheader__list-item-more']}
                    >
                        +{phones?.slice(3)?.length} meer bekijken...
                    </span>
                }
            </div>
        }
        {
            email?.length > 0 
            && <div className={styles['contactheader__list']}>
                <Title
                    size='xsmall'
                    weight='semibold'
                    transform='uppercase'
                    color='secondary'
                >
                    Email
                </Title>
                {
                    email
                    ?.sort((a, b) => Number(b.is_primary) - Number(a.is_primary))
                    ?.slice(0, 3)
                    ?.map(i => <div className={styles['contactheader__list-item']}>
                            <span onClick={copyValue(i?.value)}>{ i?.value === copyId ? 'Gekopieerd!' : i?.value }</span>
                            {
                                entity.name === 'candidate'
                                && i?.is_primary
                                && <span className={styles['contactheader__list-item-primary']}>(primair)</span>
                            }
                            {
                                entity.name === 'business_unit'
                                && i?.label
                                && <ContactHeaderItemLabel
                                    list={
                                        modulesByEntityIdByModule
                                            ?.[entity_id]
                                            ?.[MODULES.CONTACT]
                                            ?.configuration
                                            ?.labels
                                            ?.map(i => ({
                                                label: i.name,
                                                value: i.id
                                            }))
                                    }
                                    values={i?.label}
                                />
                            }
                            {
                                entity.name === 'contact'
                                && i?.relation
                                && <ContactHeaderItem
                                    entity_name={entityById?.[modulesByEntityIdByModule?.[entity_id]?.[MODULES.CONTACT]?.configuration?.[i.type]?.relation]?.name}
                                    values={i?.relation}
                                />
                            }
                        </div>
                    )
                }
                {
                    email
                    ?.slice(3)
                    ?.length > 0
                    && <span
                        onClick={handleTabClick}
                        className={styles['contactheader__list-item-more']}
                    >
                        +{email?.slice(3)?.length} meer bekijken...
                    </span>
                }
            </div>
        }
        {
            linkedin?.length > 0 
            && <div className={styles['contactheader__list']}>
                <Title
                    size='xsmall'
                    weight='semibold'
                    transform='uppercase'
                    color='secondary'
                >
                    LinkedIn
                </Title>
                {
                    linkedin
                    ?.slice(0, 3)
                    ?.map(i => <div className={styles['contactheader__list-item']}>
                            <span onClick={copyValue(i?.value)}>{ i?.value === copyId ? 'Gekopieerd!' : i?.value }</span>
                            {
                                i?.is_primary &&
                                <span className={styles['contactheader__list-item-primary']}>(primair)</span>
                            }
                        </div>
                    )
                }
            </div>
        }
    </div>
}

interface Props {
    record_id: string
    entity_id: string
}

const mapState = (state: StoreState, props: Props) => ({
    entity: getEntityById(state, props.entity_id),
    entityById: getEntitiesById(state),
    contact_methods: getContactByEntityId(state, props.record_id),
    modulesByEntityIdByModule: getModulesByEntityIdByModule(state)
});

const mapDispatch = {

}

type ContactHeaderProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(ContactHeader);